<template>
  <div class="datepicker">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
    >

      <template v-slot:activator="{ on }">

        <Input
          v-on="on"
          v-bind="$props"
          readonly
          outlined
          radius="8"
          append-icon="mdi-calendar"
          :label="label"
          :value="formatDate"
        />

      </template>

      <v-date-picker
        no-title
        scrollable
        :max="$props.max"
        :min="$props.min"
        @change="changeDate">
      </v-date-picker>

    </v-menu>
  </div>
</template>

<script>

import Input from '@/components/elements/Input'

export default {
  name: 'datepicker',
  props: {
    color: {
      default: '#212b37',
      type: String
    },
    format: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    label: {
      type: String
    },
    max: {
      type: String
    },
    min: {
      type: String
    },
    placeholder: String,
    rules: {
      type: [Array, String, Object]
    },
    'type-picker': {
      type: String
    },
    value: {
      type: String
    },
    height: { type: [String, Number] }
  },
  components: { Input },
  data: () => ({
    date: null,
    menu: false
  }),
  created () {
    this.$emit('date:update', this.value)
  },
  computed: {
    formatDate () {
      return this.date ? this.$moment(this.date).format('MM/DD/YYYY') : this.value ? this.$moment(this.value).format('MM/DD/YYYY') : ''
    }
  },
  methods: {
    changeDate ($event) {
      this.$set(this.$data, 'date', $event)
      this.$emit('date:update', $event)
      this.$refs.menu.save()
    }
  }
}
</script>

<style lang="scss" scoped>
  .datepicker {
    // ..
  }
</style>
